<ps-ui-accordion [closeOthers]="true" (toggle)="openDetails()">
  <ps-ui-accordion-section>
    <ng-template psUiAccordionTitle>
      <div class="recommended-price-title">
        <label class="pure-price-title">PurePrice™</label>
        <div class="setting-info">
          <i class="fa fa-info-circle" aria-hidden="true"></i>
          <p>
            <span
              >PurePrice™ is a machine learning process that looks at your
              project on the whole and suggests the most optimized price, based
              on the project and audience parameters and historical experience.
            </span>
          </p>
        </div>
      </div>
    </ng-template>
    <ng-template psUiAccordionContent>
      <div class="pure-price-box-div-radio-price">
        <div id="pure-price-main">
          <hr class="mt-2" />
          <div class="pure-price-box-div-radio-price">
            <div class="text-center m-5" *ngIf="loading">
              <div class="spinner-border text-primary" role="status">
                <span class="visually-hidden">Loading...</span>
              </div>
            </div>
            <div class="pure-price-main" *ngIf="!loading">
              <div
                class="controls"
                [class.d-none]="showQuotaDetails || loading"
              >
                <div class="row">
                  <div class="col">
                    <label for="averageCpi">Average CPI</label>
                    <ps-ui-range-list
                      id="averageCpi"
                      [currency]="true"
                      [steps]="averageCpi.steps"
                      (valueChange)="adjustRanges($event, true)"
                      [(value)]="averageCpi.index"
                      [disabled]="blockSelection"
                    >
                    </ps-ui-range-list>
                  </div>
                </div>
                <div class="row mt-1">
                  <div class="col">
                    <label for="fieldTime">Field Time</label>
                    <ps-ui-range
                      id="fieldTime"
                      [min]="fieldTime.min"
                      [max]="fieldTime.max"
                      [step]="1"
                      [formatter]="daysFormatter"
                      [(value)]="fieldTime.value"
                      (valueChange)="adjustRanges($event, false)"
                      [disabled]="blockSelection"
                    >
                    </ps-ui-range>
                  </div>
                </div>
                <button
                  class="btn btn-primary mt-4"
                  *ngIf="!isPurePriceApplied"
                  (click)="applyPurePrice()"
                  psUiGtagEvent
                  trackOn="click"
                  action="pure_price"
                  category="Tools"
                  [params]="{ event_label: 'Pure Price Application' }"
                >
                  Apply
                </button>
              </div>
              <hr class="mb-0" *ngIf="!showQuotaDetails" />
              <ps-ui-accordion
                class="adv-setting-accordion"
                [closeOthers]="true"
                (toggle)="quotaDetailsToggle($event)"
                *ngIf="!loading && !isPurePriceRateCardEnable"
              >
                <ps-ui-accordion-section>
                  <ng-template psUiAccordionTitle class="p-0">
                    <span>Quota Details</span>
                  </ng-template>
                  <hr *ngIf="showQuotaDetails" />
                  <ng-template psUiAccordionContent>
                    <table class="table" *ngFor="let q of quotasPurePrice">
                      <thead>
                        <tr>
                          <th>
                            <input
                              [disabled]="blockSelection"
                              id="quota-{{ q.code }}"
                              type="radio"
                              name="qualification"
                              [value]="q.code"
                              [checked]="q.code === selectedQualificationCode"
                              (change)="selectQuota(q)"
                            />
                            <label
                              for="quota-{{ q.code }}"
                              class="d-inline-block ms-1"
                              >{{ q.name }}</label
                            >
                          </th>
                          <th>CPI</th>
                          <th>Goals</th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let q of q.criterias">
                          <td>{{ q.description }}</td>
                          <td>{{ q.cpi | number : '1.2-2' }}</td>
                          <td>{{ q.goals | number }}</td>
                          <td class="blue-clr">
                            {{ q.price | number : '1.2-2' }}
                          </td>
                        </tr>
                        <tr>
                          <td class="fw-bold">Avg / Total</td>
                          <td>{{ q.cpiAvg | number : '1.2-2' }}</td>
                          <td>{{ q.goalTotal | number }}</td>
                          <td class="blue-clr fw-bolder">
                            {{ q.total | number : '1.2-2' }}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </ng-template>
                </ps-ui-accordion-section>
              </ps-ui-accordion>
              <hr class="mt-0" *ngIf="!showQuotaDetails" />
              <div class="recommended-price-footer">
                <button
                  psUiButton
                  color="danger"
                  size="small"
                  *ngIf="isPurePriceApplied && !showQuotaDetails"
                  (click)="applyPurePrice()"
                >
                  Applied to {{ appliedQuotaName }} - Click to disable
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-template>
  </ps-ui-accordion-section>
</ps-ui-accordion>
